import { QueryClient } from '@tanstack/react-query'

const SECOND = 1000
const MINUTE = 60 * SECOND

export function createAppQueryClient() {
  return new QueryClient({
    defaultOptions: {
      mutations: {
        retry: false,
      },
      queries: {
        gcTime: 5 * MINUTE,
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 30 * SECOND,
      },
    },
  })
}
